"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renameFile = void 0;

var _path = require("path");

var _trim = require("../trim/trim");

var _split = require("../split/split");

var _push = require("../push/push");

var _join = require("../join/join");

var _dropLast = require("../drop-last/drop-last");

var removeTrailingSlash = function removeTrailingSlash(source) {
  return source[source.length - 1] === _path.sep ? source.slice(0, -1) : source;
};
/**
 * Rename a file
 *
 * @param  {string}  newName   New file name
 * @param  {string}  filePath  Absolute file path
 *
 * @return {string}
 */


var renameFile = function renameFile(newName) {
  return function (filePath) {
    var _ref, _ref2, _ref3, _ref4, _filePath;

    return _ref = (_ref2 = (_ref3 = (_ref4 = (_filePath = filePath, removeTrailingSlash(_filePath)), (0, _split.split)(_path.sep)(_ref4)), (0, _dropLast.dropLast)(_ref3)), (0, _push.push)((0, _trim.trim)(_path.sep)(newName))(_ref2)), (0, _join.join)(_path.sep)(_ref);
  };
};

exports.renameFile = renameFile;